import { ALL_SCREENS } from '../Constants/configscreens.constants';

const initialState = {
    allScreens: [],
    allNames: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case ALL_SCREENS:
            return {
                allScreens: action.data.screens,
                allNames: action.data.names
            };
        default:
            return state;
    }
};
